export default function axiosCatchError(error) {
  return {
    error: error.response.data ? error.response.data.message : "error",
    code: error.response.status
  };
}
